import { Box, Container, Flex, Spinner, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Sidebar from './Sidebar';
import MobileDrawer from './MobileDrawer';
import LanguageSwitcher from './LanguageSwitcher';

interface PlatformContainerProps {
  children: React.ReactNode;
  isLoading?: boolean;
  isError?: boolean;
}

function LoadingContainer() {
  return (
    <Container my={12}>
      <Flex justifyContent="center" alignItems="center" height="100%">
        <Spinner />
      </Flex>
    </Container>
  );
}

function ErrorContainer() {
  const { t } = useTranslation('common');

  return (
    <Container my={12}>
      <Flex justifyContent="center" alignItems="center" height="100%">
        <Text>{t('somethingWentWrong')}</Text>
      </Flex>
    </Container>
  );
}

function PlatformContainer(props: PlatformContainerProps) {
  const { children, isLoading = false, isError = false } = props;

  return (
    <>
      <Sidebar />
      <Flex
        position="relative"
        flexDirection="column"
        ml={{ base: 0, lg: '240px' }}
      >
        <Box
          position="absolute"
          top={4}
          left={4}
          zIndex="sticky"
          display={{ base: 'block', lg: 'none' }}
        >
          <MobileDrawer />
        </Box>
        <Box position="absolute" top={4} right={4} zIndex="sticky">
          <LanguageSwitcher />
        </Box>
        <Container
          pt={{ base: 16, lg: 10 }}
          pb={10}
          maxW="8xl"
          ml="auto"
          mr="auto"
          flexDirection="column"
          gap={4}
          display="flex"
          justifyContent="space-between"
          height="100vh"
        >
          <Flex flexDirection="column" gap={4} flexGrow={1}>
            {isError ? (
              <ErrorContainer />
            ) : isLoading ? (
              <LoadingContainer />
            ) : (
              children
            )}
          </Flex>
        </Container>
      </Flex>
    </>
  );
}

export default PlatformContainer;
